import moment from 'moment';

const lang = String(window.navigator.language || '').toLocaleLowerCase();

/** @ignore */
export function dateFormatFilter() {
	'ngInject';
	return (date, formatString, emptyValue = '') => {
		if (date === undefined || date === '' || date === null || date === false) {
			return emptyValue;
		}
		date = moment(date);
		if (!date.isValid()) {
			return emptyValue;
		}
		if (!lang || lang === 'en-us') {
			if (formatString == 'long') {
				formatString = 'M/D/YYYY h:mma';
			}
			if (formatString == 'short') {
				formatString = 'M/D/YYYY';
			}
		} else {
			if (formatString == 'long') {
				formatString = 'D.M.YYYY HH:mm';
			}
			if (formatString == 'short') {
				formatString = 'D.M.YYYY';
			}
		}
		return date.format(formatString);
	};
}
